(ns bec-core.cljs.views.dashboard
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [cljs.core.async :as async]
            [bec-core.cljs.views.layout :as layout]
            [bec-cljs-common.utils.interop :as interop]
            [bec-cljs-common.components.input :as input]
            [bec-core.cljs.components.lookup-data :refer [svg-map-paths]]))

(defonce map-variables (r/atom {:emergency-levels #{1 2 3 4}}))

(defonce svg-zoom (r/atom 1))

(defonce map-tooltip-vars (r/atom {}))

(defn map-tooltip-content [& [props]]
  (let [id (str "map-tooltip-content" (:id props))]
    (r/create-class
      {:component-did-mount
       (fn []
         (let [element (interop/get-element-by-id id)
               width (.-clientWidth element)
               height (.-clientHeight element)]
           (swap! map-tooltip-vars assoc id {:width width
                                             :height height})))
       :component-did-update
       (fn []
         (let [element (interop/get-element-by-id id)
               width (.-clientWidth element)
               height (.-clientHeight element)]
           (swap! map-tooltip-vars assoc id {:width width
                                             :height height})))
       :display-name "map-tooltip-content"
       :reagent-render
       (fn [props]
         [:div.message
          {:id id
           :class (:class props)
           :style {:min-width "18rem"}}
          [:div.message-header
           {:on-click #(println "tooltip-header")}
           (:city (:city props))]
          (into
            [:div.message-body]
            (map
              (fn [venue]
                (into
                  [:div.box
                   {:key (first venue)}
                   [:p.subtitle
                    (or (:address (:information (second venue))) (first venue))]]
                  (if (< (:max-emergency-level props) 3)
                    (map
                      (fn [machine]
                        (when (< (:emergency-level (:information (second machine))) 3)
                          [:button.button.is-small.is-fullwidth
                           {:key (str (first machine))
                            :class (case (:emergency-level (:information (second machine)))@
                                     1 "is-danger"
                                     2 "is-warning"
                                     3 "is-info"
                                     4 "is-success")}
                           (str (:machine-id (:information (second machine))) ": "
                             (:oche-id (:information (second machine))))]))
                      (select-keys (:machines props) (:machine-ids (:information (second venue)))))
                    [[:button.button.is-small.is-fullwidth
                      {:class (case (:max-emergency-level props)
                                1 "is-danger"
                                2 "is-warning"
                                3 "is-info"
                                4 "is-success")}
                      "Go to venue"]])))
              (:venues props)))])})))

(defn map-tooltip [& [props]]
  (let [id (str "map-tooltip-content" (:id props))
        width (:width (get @map-tooltip-vars id))
        height (:height (get @map-tooltip-vars id))
        map-width (+ (:map-margin-x props) (:width @map-variables))
        tooltip-right-content-cut-x? (> (+ (/ width 2) (:x props)) map-width)
        tooltip-content-cut-x? (< (:x props) (/ width 2))
        tooltip-content-cut-y? (< (:y props) (+ height 15))]
    [:span.is-tooltip.box
     {:id (str "map-tooltip" (:id props))
      :class (str (:class props) (if tooltip-content-cut-y? " is-bottom " " is-top"))
      :style {:margin-left (cond
                             tooltip-content-cut-x? (- 3 (:x props))
                             tooltip-right-content-cut-x? (- map-width (+ width (:x props)) 3)
                             :else nil)
              :padding "0"
              "--tooltip-arrow-color" (when-not tooltip-content-cut-y?
                                        (case (:class props)
                                          "is-success" "var(--green-lightest)"
                                          "is-info" "var(--cyan-lightest)"
                                          "is-warning" "var(--yellow-lightest)"
                                          "is-danger" "var(--red-lightest)"
                                          nil))
              "--tooltip-width" (if width
                                  (str width "px")
                                  "auto")
              "--tooltip-after-position" (when width
                                           (cond
                                             tooltip-content-cut-x?
                                             (str (* 100 (/ (- (:x props) 3) width)) "%")
                                             tooltip-right-content-cut-x?
                                             (str (* 100 (/ (- (+ width (:x props) 3) map-width) width)) "%")
                                             :else nil))
              :pointer-events "all"}}
     [map-tooltip-content
      {:id (:id props)
       :city (:city props)
       :venues (:venues props)
       :machines (:machines props)
       :max-emergency-level (:max-emergency-level props)
       :class (:class props)}]]))

(defn map-marker [& [props]]
  (let [id (str "map-marker-" (:id props))
        size 1
        left (str "calc(" (:x props) "px - " (/ size 2) "rem)")
        top (str "calc(" (:y props) "px - " (/ size 2) "rem)")]
    [:div.has-tooltip.is-clickable.is-rounded.fade-in
     {:class (:class props)
      :id id
      :tab-index "4"
      :style {:position "absolute"
              :left left
              :top top
              :width (str size "rem")
              :height (str size "rem")
              :will-change "top, left"
              :transition "top 250ms ease, left 250ms ease"
              :pointer-events "none"
              :transform "none"
              :opacity "1"
              :filter "none"
              :outline "none"
              :border "none"}}
     [:button.button.is-clickable.is-rounded
      {:class (str (when (= (:class props) "is-danger") " pulsate-fwd ") (:class props))
       :tab-index "-1"
       :style {:position "absolute"
               :height "100%"
               :width "100%"
               :padding 0
               :box-shadow "0 0 0.25em var(--black)"
               "--pulsate-fwd-duration" "1.5s"
               "--pulsate-fwd-end-scale" "1.25"
               :pointer-events "all"}
       :on-click #(let [element (interop/get-element-by-id "map-overlay-container")
                        client-width (.-clientWidth element)
                        client-height (.-clientHeight element)
                        x-scroll (- (:x props) (/ client-width 2))
                        height (:height (get @map-tooltip-vars (str "map-tooltip-content" (:id props))))
                        tooltip-content-cut-y? (< (:y props) (+ height 15))
                        height-gap (- client-height height)
                        y-scroll (if tooltip-content-cut-y?
                                   (- (:y props) (if (> height-gap 0) (- (/ height-gap 2) 15) 0))
                                   (- (:y props) (- client-height (/ height-gap 2))))]
                    (interop/scroll-to element x-scroll y-scroll))}]
     [:div
      {:style {:position "relative"
               :height "100%"}}
      [map-tooltip
       {:x (:x props)
        :y (:y props)
        :map-margin-x (:map-margin-x props)
        :map-margin-y (:map-margin-y props)
        :window-width (:window-width props)
        :window-height (:window-height props)
        :city (:city props)
        :venues (:venues props)
        :machines (:machines props)
        :max-emergency-level (:max-emergency-level props)
        :id (:id props)
        :class (:class props)}]]]))

(defonce resolution (r/atom nil))

(defn svg-map
  "SVG data from https://www.amcharts.com/svg-maps/?map=worldWithAntarctica"
  [& [props]]
  [:svg#map
   (merge
     (when (map? props) props)
     {:version "1.1" :xmlns "http://www.w3.org/2000/svg" :xmlns:amcharts "http://amcharts.com/ammap"
      :xmlns-xlink "http://www.w3.org/1999/xlink" :viewBox "0 -40 1010.33 1010.33" :xml-space "preserve"})
   (into
     [:g]
     (map
       (fn [value]
         [:path.land
          {:id (first value)
           :title (:title (second value))
           :style {:stroke-width (max (/ 0.5 @svg-zoom) 0.1)}
           :on-click #(reset! layout/modal-props {:active? true
                                                  :animate-in? true
                                                  :country-id (first value)
                                                  :country (:title (second value))})
           :d (if (nil? @resolution)
                (if (> @svg-zoom 2)
                  (:high-res (second value))
                  (:low-res (second value)))
                (if (= @resolution :high-res)
                  (:high-res (second value))
                  (:low-res (second value))))}
          [:title (:title (second value))]])
       svg-map-paths))])

(defn find-xy []
  (when-let [element (interop/get-element-by-id "map")]
    (let [bounding-rect (.getBoundingClientRect element)
          width (.-width bounding-rect)
          height (.-height bounding-rect)
          locations @(rf/subscribe [:get-in [:shared-state :cities]])]
      (doseq [location locations]
        (let [location-id (first location)
              location-info (:information (second location))
              left-longitude -169.1110266
              right-longitude 190.48712
              origin-ratio-x (/ (- left-longitude) (+ right-longitude (- left-longitude)))
              origin-ratio-y 0.5
              pixel-origin-y (* origin-ratio-y height)
              pixels-per-lon-radian-y (/ height (* 2 Math/PI))
              latitude (first (:coordinates location-info))
              longitude (second (:coordinates location-info))
              rad-latitude (/ (* latitude Math/PI) 180)
              siny (Math/sin rad-latitude)
              siny (Math/min (Math/max siny -0.9999) 0.9999)
              converted-x (* width (+ origin-ratio-x (/ longitude 360)))
              converted-y (+ pixel-origin-y
                            (* 0.5 (- pixels-per-lon-radian-y)
                              (Math/log (/ (+ 1 siny) (- 1 siny)))))]
          (swap! map-variables
            (fn [a]
              (-> (assoc-in a [:locations location-id :converted-x] converted-x)
                (assoc-in [:locations location-id :converted-y] converted-y)
                (assoc-in [:locations location-id :city] location-info)
                (assoc :width width
                       :height height)))))))))

(defn center-map-scroll-position [& [unset-scroll-behavior?]]
  (when-let [map-element (interop/get-element-by-id "map")]
    (let [bounding-rect (.getBoundingClientRect map-element)
          width (.-width bounding-rect)
          height (.-height bounding-rect)]
      (when-let [element (interop/get-element-by-id "map-overlay-container")]
        (let [client-width (.-clientWidth element)
              client-height (.-clientHeight element)
              x (* (- width client-width) 0.5)
              y (* (- height client-height) 0.3)]
          (if unset-scroll-behavior?
            (set! (.-scrollBehavior (.-style element)) "unset")
            (set! (.-scrollBehavior (.-style element)) "smooth"))
          (interop/scroll-to element x y)
          (when unset-scroll-behavior?
            (set! (.-scrollBehavior (.-style element)) "smooth")))))))

(defn map-container [& [props]]
  (r/create-class
    {:component-did-mount
     #(find-xy)
     :component-did-update
     (fn [this]
       (let [props (second (js->clj (.-argv (.-props this))))]
         (when-not (:layout-animating? props)
           (center-map-scroll-position true)
           (find-xy))))
     :display-name "map-container"
     :reagent-render
     (fn [props]
       [svg-map
        (dissoc props :layout-animating? :window-width :window-height)])}))

(defn map-overlay-container [& [props]]
  (r/create-class
    {:component-did-mount
     (fn [this]
       (async/go
         (async/<! (async/timeout 500))
         (center-map-scroll-position)))
     :display-name "map-overlay-container"
     :reagent-render
     (fn [props]
       (into
         [:div#map-overlay-container.hide-scrollbar
          (when (map? props) props)]
         (r/children (r/current-component))))}))

(defonce show-map-settings? (r/atom false))

(defn view []
  (let [window-width (rf/subscribe [:window-size :width])
        window-height (rf/subscribe [:window-size :height])
        side-panel-animating? (rf/subscribe [:is-animating? :side-panel])
        map-margin-x (/ @window-width 10)
        map-margin-y (/ @window-height 10)
        cities @(rf/subscribe [:get-in [:shared-state :cities]])
        venues @(rf/subscribe [:get-in [:shared-state :venues]])
        machines @(rf/subscribe [:get-in [:shared-state :machines]])]
    [:div#content-container.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      [:div#map-controls-container.box
       {:style {:position "relative"
                :margin-top "1.5rem"
                :padding 0
                :overflow "hidden"}}
       (into
         [map-overlay-container
          {:style {:position "relative"
                   :max-height "85vh"
                   :overflow "auto"
                   :border-radius "6px"
                   :background "var(--scheme-main)"
                   :scroll-behavior (:scroll-behavior @map-variables)}}
          [map-container
           {:layout-animating? @side-panel-animating?
            :window-width @window-width
            :window-height @window-height
            :style {:width (str "calc(" (* 100 @svg-zoom) "% - " map-margin-x "px)")
                    :margin (str map-margin-y "px " (/ map-margin-x 2) "px 0 " (/ map-margin-x 2) "px")
                    :border-radius "6px"}}]]
         (for [map-var (:locations @map-variables)]
           (let [city (:city (second map-var))
                 venues (select-keys venues (:venue-ids city))
                 machine-id-list (first (map #(:machine-ids (:information (second %))) venues))
                 machines-at-location (select-keys machines machine-id-list)
                 max-emergency-level (reduce min (map #(:emergency-level (:information (second %))) machines-at-location))
                 emergency-level-checked? @(rf/subscribe [:input-checkbox (str "emergency-level-" max-emergency-level)])]
             (when emergency-level-checked?
               [map-marker
                {:id (first map-var)
                 :window-width @window-width
                 :window-height @window-height
                 :map-margin-x map-margin-x
                 :map-margin-y map-margin-y
                 :x (+ (/ map-margin-x 2) (:converted-x (second map-var)))
                 :y (+ map-margin-y (:converted-y (second map-var)))
                 :city city
                 :venues venues
                 :machines machines
                 :max-emergency-level max-emergency-level
                 :class (case max-emergency-level
                          4 "is-success"
                          3 "is-info"
                          2 "is-warning"
                          1 "is-danger")}]))))
       [:div
        {:style {:position "absolute"
                 :top "0.25rem"
                 :right "0.25rem"
                 :z-index "3"
                 :display "flex"
                 :flex-direction "column"
                 :align-items "flex-end"}}
        [:button.button
         {:style {:margin "0.25em"}
          :on-click #(reset! svg-zoom (* 2 @svg-zoom))}
         [:span.icon
          {:aria-label "Zoom in"}
          [:i.fas.fa-plus]]]
        [:button.button
         {:style {:margin "0.25em"}
          :on-click #(when (> @svg-zoom 1)
                       (reset! svg-zoom (/ @svg-zoom 2)))}
         [:span.icon
          {:aria-label "Zoom in"}
          [:i.fas.fa-minus]]]]
       [:button.button
        {:style {:position "absolute"
                 :top "0.125rem"
                 :left "0.125rem"
                 :z-index "3"
                 :display "flex"
                 :flex-direction "column"
                 :justify-content "center"
                 :width "1.5em"
                 :height "2.75rem"
                 :padding 0
                 :margin 0
                 :transform (if @show-map-settings?
                              "translateX(18rem)"
                              "translateX(0rem)")
                 :transition "transform var(--transition-duration) ease"}
         :on-click #(reset! show-map-settings? (not @show-map-settings?))}
        [:span.icon
         {:aria-label "More options"}
         [:i
          {:class (if @show-map-settings?
                    "fas fa-angle-left"
                    "fas fa-angle-right")
           :aria-hidden @show-map-settings?}]]]
       [:div.card
        {:style {:position "absolute"
                 :top "0"
                 :left "0"
                 :z-index "3"
                 :display "flex"
                 :flex-direction "column"
                 :width "18rem"
                 :height "100%"
                 :border-radius "0"
                 :transform (if @show-map-settings?
                              "translateX(0rem)"
                              "translateX(-19rem)")
                 :transition "transform var(--transition-duration) ease"}}
        [:header {:class "card-header"}
         [:p {:class "card-header-title"}
          "Map settings"]]
        [:div.card-content
         {:style {:overflow "auto"}}
         [:div.box
          [:label.has-input
           {:style {:display "flex"
                    :align-items "center"}}
           [:input.is-rounded.is-switch
            {:on-key-up (fn [event]
                          (when (or (= event.key "Enter") (= event.keyCode 13))
                            (reset! resolution :high-res)))
             :on-change (fn [event]
                          (reset! resolution :high-res))
             :checked (= @resolution :high-res)
             :type "checkbox"}]
           "High resolution map"]]
         [:div.box
          [:label.has-input
           {:style {:display "flex"
                    :align-items "center"}}
           [:input.is-rounded.is-switch
            {:on-key-up (fn [event]
                          (when (or (= event.key "Enter") (= event.keyCode 13))
                            (reset! resolution :low-res)))
             :on-change (fn [event]
                          (reset! resolution :low-res))
             :checked (= @resolution :low-res)
             :type "checkbox"}]
           "Low resolution map"]]
         [:div.box
          [:label.has-input
           {:style {:display "flex"
                    :align-items "center"}}
           [:input.is-rounded.is-switch
            {:on-key-up (fn [event]
                          (when (or (= event.key "Enter") (= event.keyCode 13))
                            (reset! resolution nil)))
             :on-change (fn [event]
                          (reset! resolution nil))
             :checked (nil? @resolution)
             :type "checkbox"}]
           "System controlled"]]
         (into
           [:div.box
            [:p {:style {:margin-bottom "0.5rem"}}
             "Emergency levels"]]
           (map
             (fn [level]
               [input/switch
                {:id (str "emergency-level-" level)
                 :class "is-rounded"}
                (str "Show level " level)])
             [1 2 3 4]))]]]]]))
